import Dropdown from '@/components/dropdown/Dropdown.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import InputText from '@/components/inputText/InputText.vue'
import { get } from 'http'

export default {
    name: 'dropdown-search',
    data() {
        return {
            scroll: false,
            container: document.body,
        }
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        value: {
            default: null, // String 
        },
        /**
         * при множественном выборе
         * предполагается, что выбираться будут все
         * по умолчанию, поэтому в этом случае placeholder
         * обязателен
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * максимальное количество показа элементов
         */
        max: {
            type: Number,
            default: 3,
        },
        /**
         * классы стилей
         */
        type: {
            type: String,
        },
        idField: {
            type: String,
            default: 'id'
        },
        nameField: {
            type: String,
            default: 'name'
        }
    },
    computed: {
        getOptionName() {
            return option => {
                if (typeof option === 'object') {
                    return option[this.nameField]
                }
                return option
            }
        },
        dropdownHeight() {
            if (this.filteredList.length > 3) {
                return 90
            }

            if (this.filteredList.length === 1) {
                return 32
            }

            return this.filteredList.length * 30
        },
        dropdownStyle() {
           return { height: `${this.dropdownHeight}px !important`, maxHeight: `${this.dropdownHeight}px !important`}
        },
        inputedText: {
            get() {
                return this.value
            },
            set(value) {
                this.emitValue(value)
            }
        },
        filteredList() {
            if (!this.inputedText) {
                return this.list
            }

            return this.list.filter((itemInList) => itemInList[this.nameField].toLowerCase().includes(this.inputedText.toLowerCase()))
        }
    },
    methods: {
        emitValue(emitedValue) {
            this.$emit('update:value', emitedValue)
            this.$emit('change', emitedValue)
            this.$emit('input', emitedValue)
            this.$emit('blur')
        },
        select(item) {
            this.emitValue(item[this.nameField])
        },
        openDropdown() {
            let option = this.$refs.scroll.$el.getElementsByClassName('first')[0]
            let content = this.$refs.options
            let wrap = this.$refs.wrap



            if (option && content) {
                this.$nextTick(() => {
                    let itemHeight = option.clientHeight + this.getStyleValue(option, 'marginBottom') + this.getStyleValue(option, 'marginTop')
                    let maxHeight = itemHeight * this.max + this.getStyleValue(wrap, 'paddingBottom') + this.getStyleValue(wrap, 'paddingTop')
                    let height = this.list.length * itemHeight
                    this.scroll = height > maxHeight

                    content.style.height = this.scroll ? maxHeight + 'px' : 'auto'

                    this.$refs.scroll.update()
                    this.$emit('select:open')
                })
            }
        },
        getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style])
        },
        openDropDownSearch() {

            if (this.$refs.dropdown.show) {
                return
            }

            this.$refs.dropdown.toggle({
                target: this.$refs.dropdown.$el
            })

        }

    },
    components: {
        Dropdown,
        VuePerfectScrollbar,
        InputText
    }
}


// WEBPACK FOOTER //
// ./src/components/dropDownSearch/dropdownSearch.js